// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__D58Qn","list":"list__4f04I","error":"error__C5ES-","list-wrapper":"list-wrapper__+EFGX","new-feed-msg":"new-feed-msg__Kxuqr"};